/**
 * Configurações específicas para o cliente "Amigoz Consig"
 */
const settings: ClientSettings = {
  name: "Amigoz Consig",
  benefitCardName: "Amigoz",
  insuranceName: "Amigoz Med",
  theme: {
    token: {
      colorPrimary: "#00A2E0",
      colorHighlight: "#2DCCD2",
    },
  },
  assets: {
    background: "/background.png",
    logo: "/logo.png",
    favicon: "/favicon.png",
    card: "/card.png",
    consignedCard: "/consigned-card.png",
  },
  cardExclusiveTheme: {
    name: "Amigoz",
    theme: {
      token: {
        colorPrimary: "#00A2E0",
        colorHighlight: "#2DCCD2",
      },
    },
    assets: {
      background: "/background-card-exclusive.png",
      logo: "/logo-card-exclusive.png",
      favicon: "/favicon-card-exclusive.png",
    },
  },
};

export default settings;
